import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

export const fetchEmployeeData = createAsyncThunk(
  "employeeData/fetchEmployeeData",
  async ({ url, FormDataDynamic }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        url,
        FormDataDynamic, // ✅ plain object — JSON.stringify hata diya
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching employee data:", error);
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

const employeeDataSlice = createSlice({
  name: "employeeData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEmployeeData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(fetchEmployeeData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.error.message;
      });
  },
});

export default employeeDataSlice.reducer;